{
  "home": {
    "status": {
      "pending": "Awaiting approval",
      "approved": "Live",
      "rejected": "Not approved"
    },
    "spots": "Opncue spots",
    "headline": "Become known as a place where people connect.",
    "intro": "Claim your venue, share your spot page, and watch real conversations happen. It’s free.",
    "claim": "Claim your venue",
    "yourSpots": "Your spots",
    "empty": "You haven’t claimed a venue yet.",
    "signInBody": "Sign in to the Opncue app with your business email to claim and manage your spot.",
    "signIn": "Sign in"
  },
  "claim": {
    "searchError": "Couldn’t search venues. Try again.",
    "claimError": "Couldn’t claim this venue.",
    "signInTitle": "Sign in to claim your venue",
    "signInBody": "Use the Opncue app to sign in with your business email first.",
    "signIn": "Sign in",
    "title": "Claim your venue",
    "intro": "Search for your venue. Once you claim it, we’ll review and approve it, then your spot page goes live.",
    "placeholder": "Your venue name",
    "search": "Search",
    "claim": "Claim"
  },
  "admin": {
    "title": "Claim approvals",
    "accessRequired": "Admin access required. Add your email to ADMIN_EMAILS on the server to review claims.",
    "empty": "No pending claims. You’re all caught up.",
    "unknownOwner": "Unknown owner",
    "reject": "Reject",
    "approve": "Approve"
  },
  "public": {
    "notFound": "Spot not found",
    "notFoundBody": "This spot may not be active yet.",
    "active": "Active Opncue spot",
    "welcomeFallback": "People are open to friendly conversation here today.",
    "thisWeek": "This week",
    "goodSpots": "Good spots to meet",
    "conversations_one": "{{count}} conversation started",
    "conversations_other": "{{count}} conversations started",
    "groups_one": "{{count}} group formed",
    "groups_other": "{{count}} groups formed",
    "meetups_one": "{{count}} meetup moment sparked",
    "meetups_other": "{{count}} meetup moments sparked",
    "atVenue": "You’re near {{venue}}. Open the app to see who’s visible here.",
    "notAtVenue": "You need to be at the venue to join this space—Opncue only lets people join when they’re actually there.",
    "open": "Open Opncue",
    "directions": "Get directions",
    "share": "Share with a friend",
    "shareMessage": "{{venue}} is an Opncue spot—come by and meet people already here."
  },
  "dashboard": {
    "rejected": "This claim wasn’t approved. Contact support if this is a mistake.",
    "pending": "Your claim is awaiting approval. Your spot page goes live once approved.",
    "thisWeek": "This week",
    "stats": {
      "conversations": "Conversations",
      "groups": "Groups formed",
      "meetups": "Meetup moments",
      "visible": "People visible"
    },
    "welcome": "Welcome note",
    "welcomePlaceholder": "A warm line for visitors, e.g. “Grab a seat and say hi.”",
    "meetupSpots": "Meetup spots",
    "meetupPlaceholder": "By the window, Near the counter",
    "commaHint": "Separate with commas.",
    "saving": "Saving…",
    "save": "Save changes",
    "shareSpot": "Share your spot",
    "spotLink": "Spot link",
    "storyLabel": "Instagram story text",
    "postLabel": "Social post text",
    "sharePage": "Share spot page",
    "copied": "Copied",
    "copy": "Copy",
    "storyText": "We’re an Opncue spot. Come by, open Opncue, and meet people already here. {{url}}",
    "postText": "Opncue spot: {{venue}}\nPeople are open to friendly conversation here.\nThis week: {{count}} conversations started.\nCome by and say hi. {{url}}"
  }
}
